import { infraMetricsRepo } from './core';

export type {
  DatabaseMetrics,
  InfraMetricSource,
  InfraMetricsSnapshot,
  MetricSourceStatus,
  SystemMetrics,
} from '@modules/infraMetrics';

export const getInfraMetricsSnapshot = infraMetricsRepo.getSnapshot.bind(infraMetricsRepo);
